"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchUniV2PairData = exports.getOrCreateContractByType = exports.getOrCreateContractByAddress = void 0;
const caip_1 = require("@shapeshiftoss/caip");
const types_1 = require("@shapeshiftoss/types");
const sdk_1 = require("@uniswap/sdk");
const assert_1 = __importDefault(require("assert"));
const memoize_1 = __importDefault(require("lodash/memoize"));
const viem_1 = require("viem");
const constants_1 = require("./constants");
const ethersProviderSingleton_1 = require("./ethersProviderSingleton");
const types_2 = require("./types");
const viemClient_1 = require("./viemClient");
const definedContracts = {};
const getOrCreateContractByAddress = (address) => {
    const checksumAddress = (0, viem_1.getAddress)(address);
    const definedContract = definedContracts[checksumAddress];
    if (definedContract !== undefined) {
        return definedContract;
    }
    const contractAbi = constants_1.CONTRACT_ADDRESS_TO_ABI[address];
    const contract = (0, viem_1.getContract)({
        abi: contractAbi,
        address: checksumAddress,
        client: viemClient_1.viemEthMainnetClient,
    });
    definedContracts[checksumAddress] = contract;
    return contract;
};
exports.getOrCreateContractByAddress = getOrCreateContractByAddress;
const getOrCreateContractByType = ({ address, type, chainId, }) => {
    const checksumAddress = (0, viem_1.getAddress)(address);
    const definedContract = definedContracts[checksumAddress];
    if (definedContract !== undefined) {
        return definedContract;
    }
    const publicClient = viemClient_1.viemClientByChainId[chainId];
    (0, assert_1.default)(publicClient !== undefined, `no public client found for chainId '${chainId}'`);
    const contract = (0, viem_1.getContract)({
        abi: constants_1.CONTRACT_TYPE_TO_ABI[type],
        address: checksumAddress,
        client: publicClient,
    });
    definedContracts[checksumAddress] = contract;
    return contract;
};
exports.getOrCreateContractByType = getOrCreateContractByType;
exports.fetchUniV2PairData = (0, memoize_1.default)(async (pairAssetId) => {
    const { assetReference, chainId } = (0, caip_1.fromAssetId)(pairAssetId);
    const checksumAddress = (0, viem_1.getAddress)(assetReference);
    const pair = (0, exports.getOrCreateContractByType)({
        address: checksumAddress,
        type: types_2.ContractType.UniV2Pair,
        chainId: types_1.KnownChainIds.EthereumMainnet,
    });
    const ethersV5Provider = (0, ethersProviderSingleton_1.getEthersV5Provider)();
    const token0Address = await pair.read.token0();
    const token1Address = await pair.read.token1();
    const token0AssetId = (0, caip_1.toAssetId)({
        chainId,
        assetNamespace: 'erc20',
        assetReference: token0Address,
    });
    const token1AssetId = (0, caip_1.toAssetId)({
        chainId,
        assetNamespace: 'erc20',
        assetReference: token1Address,
    });
    const { chainReference: asset0EvmChainId, assetReference: asset0Address } = (0, caip_1.fromAssetId)(token0AssetId);
    const { chainReference: asset1EvmChainId, assetReference: asset1Address } = (0, caip_1.fromAssetId)(token1AssetId);
    const token0 = await sdk_1.Fetcher.fetchTokenData(Number(asset0EvmChainId), asset0Address, ethersV5Provider);
    const token1 = await sdk_1.Fetcher.fetchTokenData(Number(asset1EvmChainId), asset1Address, ethersV5Provider);
    return sdk_1.Fetcher.fetchPairData(token0, token1, ethersV5Provider);
});
